window.Drawers = (function () {
    var Drawer = function (id, position, options) {
        var defaults = {
            close: ".js-drawer-close",
            open: ".js-drawer-open-" + position,
            openClass: "js-drawer-open",
            dirOpenClass: "js-drawer-open-" + position,
        };

        this.nodes = {
            $parent: $("body, html"),
            $page: $(".page-element"),
            $moved: null //$(".is-moved-by-drawer"),
        };

        this.config = $.extend(defaults, options);
        this.position = position;

        this.$drawer = $("#" + id);
        this.$open = $(this.config.open);

        if (!this.$drawer.length) {
            return false;
        }

        this.drawerIsOpen = false;
        this.init();
    };

    Drawer.prototype.init = function () {
        this.$open.attr("aria-expanded", "false");
        this.$open.on("click", $.proxy(this.open, this));
        this.$drawer
            .find(this.config.close)
            .on("click", $.proxy(this.close, this));
    };

    Drawer.prototype.open = function (evt) {
        // Keep track if drawer was opened from a click, or called by another function
        var externalCall = false;

        // don't open an opened drawer
        if (this.drawerIsOpen) {
            return;
        }

        this.$open.addClass(this.config.openClass);

        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }

        // Without this, the drawer opens, the click event bubbles up to $nodes.page
        // which closes the drawer.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
        }

        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }

        // Add is-transitioning class to moved elements on open so drawer can have
        // transition for close animation
        // this.nodes.$moved.addClass("is-transitioning");
        this.$drawer.prepareTransition();

        this.nodes.$parent.addClass(
            this.config.openClass + " " + this.config.dirOpenClass
        );
        this.drawerIsOpen = true;

        // Set focus on drawer
        slate.a11y.trapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus",
        });

        // Run function when drawer opens if set
        if (
            this.config.onDrawerOpen &&
            typeof this.config.onDrawerOpen === "function"
        ) {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }

        if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
            this.$activeSource.attr("aria-expanded", "true");
        }

        this.bindEvents();
    };

    Drawer.prototype.close = function () {
        // don't close a closed drawer
        if (!this.drawerIsOpen) {
            return;
        }

        this.$open.removeClass(this.config.openClass);

        // deselect any focused form elements
        $(document.activeElement).trigger("blur");

        // Ensure closing transition is applied to moved elements, like the nav
        // this.nodes.$moved.prepareTransition({ disableExisting: true });
        this.$drawer.prepareTransition({ disableExisting: true });

        this.nodes.$parent.removeClass(
            this.config.dirOpenClass + " " + this.config.openClass
        );

        this.drawerIsOpen = false;

        // Remove focus on drawer
        slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus",
        });

        if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
            this.$activeSource.attr("aria-expanded", "false");
        }

        this.unbindEvents();
    };

    Drawer.prototype.bindEvents = function () {
        // Lock scrolling on mobile
        this.nodes.$page.on("touchmove.drawer", function () {
            return false;
        });

        // Clicking out of drawer closes it
        this.nodes.$page.on(
            "click.drawer",
            $.proxy(function () {
                this.close();
                return false;
            }, this)
        );

        // Pressing escape closes drawer
        this.nodes.$parent.on(
            "keyup.drawer",
            $.proxy(function (evt) {
                if (evt.keyCode === Keycodes.ESCAPE) {
                    this.close();
                }
            }, this)
        );
    };

    Drawer.prototype.unbindEvents = function () {
        this.nodes.$page.off(".drawer");
        this.nodes.$parent.off(".drawer");
    };

    return Drawer;
})();

window.Modals = (function () {
    var Modal = function (id, name, options) {
        var defaults = {
            close: ".js-modal-close",
            open: ".js-modal-open-" + name,
            openClass: "modal--is-active",
        };

        this.$modal = $("#" + id);

        if (!this.$modal.length) {
            return false;
        }

        this.nodes = {
            $body: $("body"),
        };

        this.config = $.extend(defaults, options);

        this.modalIsOpen = false;
        this.$focusOnOpen = this.config.focusOnOpen
            ? $(this.config.focusOnOpen)
            : this.$modal;
        this.init();
    };

    Modal.prototype.init = function () {
        var $openBtn = $(this.config.open);

        // Add aria controls
        $openBtn.attr("aria-expanded", "false");

        $(this.config.open).on("click", $.proxy(this.open, this));
        this.$modal
            .find(this.config.close)
            .on("click", $.proxy(this.close, this));
    };

    Modal.prototype.open = function (evt) {
        // Keep track if modal was opened from a click, or called by another function
        var externalCall = false;

        // don't open an opened modal
        if (this.modalIsOpen) {
            return;
        }

        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }

        // Without this, the modal opens, the click event bubbles up to $nodes.page
        // which closes the modal.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
        }

        if (this.modalIsOpen && !externalCall) {
            return this.close();
        }

        this.$modal.prepareTransition().addClass(this.config.openClass);
        this.nodes.$body.addClass(this.config.openClass);

        this.modalIsOpen = true;

        // Set focus on modal
        slate.a11y.trapFocus({
            $container: this.$modal,
            namespace: "modal_focus",
            $elementToFocus: this.$focusOnOpen,
        });

        if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
            this.$activeSource.attr("aria-expanded", "true");
        }

        this.bindEvents();
    };

    Modal.prototype.close = function () {
        // don't close a closed modal
        if (!this.modalIsOpen) {
            return;
        }

        // deselect any focused form elements
        $(document.activeElement).trigger("blur");

        this.$modal.prepareTransition().removeClass(this.config.openClass);
        this.nodes.$body.removeClass(this.config.openClass);

        this.modalIsOpen = false;

        // Remove focus on modal
        slate.a11y.removeTrapFocus({
            $container: this.$modal,
            namespace: "modal_focus",
        });

        if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
            this.$activeSource.attr("aria-expanded", "false").trigger('focus');
        }

        this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
        // Pressing escape closes modal
        this.nodes.$body.on(
            "keyup.modal",
            $.proxy(function (evt) {
                if (evt.keyCode === Keycodes.ESCAPE) {
                    this.close();
                }
            }, this)
        );
    };

    Modal.prototype.unbindEvents = function () {
        this.nodes.$body.off(".modal");
    };

    return Modal;
})();

window.Meganav = (function () {
    var Meganav = function (options) {
        this.cache = {
            $document: $(document),
            $page: $(".page-element"),
        };

        var defaults = {
            $meganavs: $(".meganav"),
            $megaNav: $(".meganav__nav"),
            $meganavToggle: $(".meganav-toggle"),
            $meganavDropdownContainers: $(".site-nav__dropdown-container"),
            $meganavToggleThirdLevel: $(".meganav__link-toggle"),
            $meganavLinkSecondLevel: $(".meganav__link--second-level"),
            $meganavLinkThirdLevel: $(".meganav__link--third-level"),
            $meganavDropdownThirdLevel: $(".site-nav__dropdown--third-level"),
            isOpen: false,
            preventDuplicates: false,
            closeOnPageClick: false,
            closeThirdLevelOnBlur: false,
            activeClass: "meganav--active",
            drawerClass: "meganav--drawer",
            meganavDropdown: ".site-nav__dropdown",
            meganavLinkClass: "meganav__link",
            drawerToggleClass: "drawer__nav-toggle-btn",
            drawerNavItem: ".drawer__nav-item",
            navCollectionClass: "meganav__nav--collection",
            secondLevelClass: "meganav__link--second-level",
            thirdLevelClass: "meganav__link-toggle",
            thirdLevelContainerClass: "site-nav__dropdown--third-level",
            noAnimationClass: "meganav--no-animation",
        };

        this.config = $.extend(defaults, options);
        this.init();
    };

    Meganav.prototype.init = function () {
        var $openBtn = this.config.$meganavToggle;

        $openBtn.on("click", $.proxy(this.requestMeganav, this));

        if (this.config.closeThirdLevelOnBlur) {
            this.config.$meganavLinkThirdLevel.on(
                "blur",
                $.proxy(this.closeThirdLevelMenu, this)
            );
        }
    };

    Meganav.prototype.requestMeganav = function (evt) {
        var $targetedMeganav;

        // Prevent following href if link is clicked
        if (evt) {
            evt.preventDefault();
        }

        // Without this, the meganav opens, the click event bubbles up to
        // theme.cache.$page which closes the drawer.
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
        }

        var $el = $(evt.currentTarget);
        var anotherNavIsOpen = this.config.isOpen;
        var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

        // The $targetedMeganav is different for the drawer and non-drawer navs
        if ($el.hasClass(this.config.drawerToggleClass)) {
            $targetedMeganav = $el
                .closest(this.config.drawerNavItem)
                .children("." + this.config.drawerClass);
        } else {
            $targetedMeganav = $el.siblings(this.config.meganavDropdown);
        }

        // Navigate to link href or close menu if already active
        if ($el.hasClass(this.config.activeClass) && $el.is("a")) {
            window.location = $el.attr("href");
            return;
        }

        // If true, don't let multiple meganavs be open simultaneously
        if (!isThirdLevelBtn && this.config.preventDuplicates) {
            this.close();
        }

        if ($targetedMeganav.hasClass(this.config.drawerClass)) {
            var isExpanded = $el.attr("aria-expanded") === "true";

            $el.toggleClass(this.config.activeClass).attr(
                "aria-expanded",
                !isExpanded
            );

            $targetedMeganav.stop().slideToggle(200);
        } else {
            $el.addClass(this.config.activeClass).attr("aria-expanded", "true");

            // Show targeted nav, letting it know whether another meganav is already open
            this.open($el, $targetedMeganav, anotherNavIsOpen);
        }

        // Setup event handlers when meganav is open
        this.bindEvents();
        this.config.isOpen = true;

        // If dropdown has third level, calculate width for container
        var $dropdown = $el.next();
        var isCollection = $dropdown
            .find(this.config.$megaNav)
            .hasClass(this.config.navCollectionClass);

        if (isCollection) {
            this.updateThirdLevelContainerWidth($el, $dropdown);
        }
    };

    Meganav.prototype.updateThirdLevelContainerWidth = function (
        $el,
        $dropdown
    ) {
        var $thirdLevel = $dropdown.find(
            this.config.$meganavDropdownThirdLevel
        );

        if (!$thirdLevel.length) {
            return;
        }

        $.each(
            $thirdLevel,
            function (key, container) {
                var $container = $(container);
                var $lastChild = $container.find("li:last-child");

                this.updateContainerWidth($container, $lastChild);
            }.bind(this)
        );
    };

    Meganav.prototype.updateContainerWidth = function (container, element) {
        var containerRect = container[0].getBoundingClientRect();
        var elementRect = element[0].getBoundingClientRect();

        if (elementRect.left < containerRect.right) {
            return;
        }

        var columnWidth = containerRect.width;
        var containerFixedWidth =
            elementRect.left + columnWidth - containerRect.left;
        var numberOfColumns = containerFixedWidth / columnWidth;
        var containerPercentageWidth = numberOfColumns * 20;

        container
            .width(containerPercentageWidth + "%")
            .find("li")
            .css("width", 100 / numberOfColumns + "%");
    };

    Meganav.prototype.open = function ($el, $target, noAnimation) {
        var isThirdLevelBtn = $el.hasClass(this.config.thirdLevelClass);

        $target.addClass(this.config.activeClass);

        if (isThirdLevelBtn) {
            this.toggleSubNav($el, $target);
        }

        // Add class to override animation - CSS determined
        if (noAnimation) {
            $target.addClass(this.config.noAnimationClass);
        }
    };

    Meganav.prototype.toggleSubNav = function ($el) {
        this.removeMenuActiveState();

        $el.addClass(this.config.activeClass)
            .attr("aria-expanded", "true")
            .siblings(this.config.$meganavDropdownThirdLevel)
            .addClass(this.config.activeClass);

        $el.parent().addClass(this.config.activeClass);
    };

    Meganav.prototype.close = function (evt, $target) {
        if (this.config.preventDuplicates) {
            // Close all meganavs
            this.config.$meganavs.removeClass(
                [this.config.activeClass, this.config.noAnimationClass].join(
                    " "
                )
            );
            this.config.$meganavToggle
                .removeClass(this.config.activeClass)
                .attr("aria-expanded", "false");

            this.config.$meganavDropdownContainers.removeClass(
                this.config.activeClass
            );
        } else {
            // Close targeted nav
            var $targetedMeganav = $("#" + $target.attr("aria-controls"));
            $targetedMeganav.removeClass(
                [this.config.activeClass, this.config.noAnimationClass].join(
                    " "
                )
            );
            $target
                .removeClass(this.config.activeClass)
                .attr("aria-expanded", "false");
        }

        // Remove event listeners
        this.unbindEvents();
        this.config.isOpen = false;
    };

    Meganav.prototype.closeThirdLevelMenu = function (evt) {
        var $el = $(evt.currentTarget);
        var $parent = $el.parent();

        if (!$parent.is(":last-child")) {
            return;
        }

        this.config.$meganavLinkSecondLevel.one(
            "focus.meganav",
            $.proxy(function () {
                this.removeMenuActiveState();
            }, this)
        );
    };

    Meganav.prototype.removeMenuActiveState = function () {
        var activeClasses = [
            this.config.activeClass,
            this.config.noAnimationClass,
        ];

        this.config.$meganavToggleThirdLevel
            .removeClass(activeClasses.join(" "))
            .attr("aria-expanded", "false");

        this.config.$meganavDropdownThirdLevel.removeClass(
            activeClasses.join(" ")
        );
        this.config.$meganavDropdownContainers.removeClass(
            this.config.activeClass
        );
    };

    Meganav.prototype.bindEvents = function () {
        if (!this.config.closeOnPageClick) {
            return;
        }

        // Clicking away from the meganav will close it
        this.cache.$page.on("click.meganav", $.proxy(this.close, this));

        // Exception to above: clicking anywhere on the meganav will NOT close it
        this.config.$meganavs.on(
            "click.meganav",
            function (evt) {
                // 3rd level container
                var is3rdLevelMenuTarget =
                    $(evt.currentTarget).hasClass(this.config.activeClass) &&
                    $(evt.currentTarget).hasClass(
                        this.config.thirdLevelContainerClass
                    );

                // 2nd level mega link
                var isMegaNavlink =
                    $(evt.target).hasClass(this.config.meganavLinkClass) &&
                    $(evt.target).hasClass(this.config.secondLevelClass);

                // If we click anything outside from the 3rd level megaNav, close the third level menu (except for 2nd level links)
                if (!is3rdLevelMenuTarget && !isMegaNavlink) {
                    this.removeMenuActiveState();
                }

                evt.stopImmediatePropagation();
            }.bind(this)
        );

        // Pressing escape closes meganav and focuses the target parent link
        this.cache.$document.on(
            "keyup.meganav",
            $.proxy(function (evt) {
                if (evt.keyCode !== Keycodes.ESCAPE) return;

                this.config.$meganavToggle
                    .filter("." + this.config.activeClass)
                    .trigger('focus');
                this.close();
            }, this)
        );
    };

    Meganav.prototype.unbindEvents = function () {
        if (!this.config.closeOnPageClick) {
            return;
        }

        this.cache.$page.off(".meganav");
        this.config.$meganavs.off(".meganav");
        this.cache.$document.off(".meganav");
        this.config.$meganavLinkSecondLevel.off(".meganav");
        this.config.$meganavLinkThirdLevel.off(".meganav");
    };

    return Meganav;
})();

window.Notify = (function () {
    var notify = function () {
        this.cache = {
            $scrollParent: $("html").add("body"),
            $notificationSuccess: $("#NotificationSuccess"),
            $notificationSuccessLink: $("#NotificationSuccess").find("a"),
            $notificationError: $("#NotificationError"),
            $notificationPromo: $("#NotificationPromo"),
            $notificationClose: $(".notification__close"),
            $notificationErrorMessage: $(".notification__message--error"),
            $body: $("body"),
            $subtotal: $("#CartSubtotal"),
            $diff: $("#deltaamt"),
            $discountTotal: $("#cartDiscountTotal"),
            $cartTable: $(".cart-table"),
            $cartTemplate: $("#CartProducts"),
        };

        this.settings = {
            notifyActiveClass: "notification--active",
            closeTimer: 5000,
            promoKeyName: "promo-" + this.cache.$notificationPromo.data("text"),
        };

        this.notifyTimer;
        this.$lastFocusedElement = null;

        this.isLocalStorageSupported = isLocalStorageSupported();

        this.cache.$notificationClose.on("click", this.close.bind(this));
        this.showPromo();
    };

    function isLocalStorageSupported() {
        // Return false if we are in an iframe without access to localStorage
        if (window.self !== window.top) {
            return false;
        }

        var testKey = "test";
        try {
            var storage = window.localStorage;
            storage.setItem(testKey, "1");
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    }
    notify.prototype.open = function (state, message, autoclose) {
        this.close();

        if (state === "success") {
            this.cache.$notificationSuccess
                .attr("aria-hidden", false)
                .addClass(this.settings.notifyActiveClass);

            // Set last focused element to return to once success
            // notification is dismissed (by timeout)
            this.$lastFocusedElement = $(document.activeElement);

            // Set focus on link to cart after transition
            this.cache.$notificationSuccess.one(
                "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
                $.proxy(function () {
                    slate.a11y.pageLinkFocus(
                        this.cache.$notificationSuccessLink
                    );
                }, this)
            );

            // Fallback for no transitions
            if (this.cache.$scrollParent.hasClass("no-csstransitions")) {
                slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
            }
        } else {
            this.cache.$notificationErrorMessage.html(message);
            this.cache.$notificationError
                .attr("aria-hidden", false)
                .addClass(this.settings.notifyActiveClass);
        }

        // Timeout to close the notification
        if (autoclose) {
            clearTimeout(this.notifyTimer);
            this.notifyTimer = setTimeout(
                this.close.bind(this),
                this.settings.closeTimer
            );
        }
    };

    notify.prototype.close = function (evt) {
        if (
            evt &&
            $(evt.currentTarget).attr("id") === "NotificationPromoClose"
        ) {
            if (this.isLocalStorageSupported) {
                localStorage.setItem(this.settings.promoKeyName, "hidden");
            }
        }

        // Return focus to previous element if one is defined
        // and the user has not strayed from the success notification link
        if (
            this.$lastFocusedElement &&
            this.cache.$notificationSuccessLink.is(":focus")
        ) {
            slate.a11y.pageLinkFocus(this.$lastFocusedElement);
        }

        // Close all notification bars
        this.cache.$notificationSuccess
            .attr("aria-hidden", true)
            .removeClass(this.settings.notifyActiveClass);
        this.cache.$notificationError
            .attr("aria-hidden", true)
            .removeClass(this.settings.notifyActiveClass);
        this.cache.$notificationPromo
            .attr("aria-hidden", true)
            .removeClass(this.settings.notifyActiveClass);

        // Reset last focused element
        this.$lastFocusedElement = null;
    };

    notify.prototype.showPromo = function (SFEevent) {
        // If reloaded in the storefront editor, update selectors/settings
        if (SFEevent) {
            this.initCache();
        }

        if (
            this.isLocalStorageSupported &&
            localStorage[this.settings.promoKeyName] === "hidden"
        ) {
            return;
        }

        this.cache.$notificationPromo
            .attr("aria-hidden", false)
            .addClass(this.settings.notifyActiveClass);
    };

    return notify;
})();